import { FormattedMessage } from 'react-intl';
import { useAppNavigate, useAppSelector } from '../../../configuration/setup/hooks';
import { type AppRoute, ROUTE_EUROPE, ROUTE_LATAM } from '../../app/routes/routes';
import { Region, regionSelector } from '../../region/regionSlice';

export const PersonalBackButton = ({ isLoading }: { isLoading: boolean }) => {
    const navigate = useAppNavigate();
    const region = useAppSelector(regionSelector);
    const navigationTarget: AppRoute = region === Region.latinamerica ? ROUTE_LATAM : ROUTE_EUROPE;

    return (
        <button
            type={'button'}
            disabled={isLoading}
            onClick={e => {
                e.preventDefault();
                navigate(navigationTarget);
            }}
            className={'btn btn-primary'}
        >
            <span className={'uikit-icon icon-chevron-left'} />
            <FormattedMessage id={'intl-msg:registration.personalData.backButtonLabel'} />
        </button>
    );
};
